app.controller("ProfileController", ["$scope", "$state", "AuthService", "StaticData",
    function ($scope, $state, AuthService, StaticData) {
        localStorage.setItem("INACTIVE_SESSION_TIME", 60000)

        $scope.showList = [];
        $scope.typeCast = {
            "manager": "sudo.users",
            "admin": "admin.subject",
            "student": "student-new.index",
            "lecturer": "lecturer.index",
            "employee": "employee.documents.incoming"
        };

        $scope.logout = function () {
            AuthService.logout().then(function () {
                $state.go("login");
            });
        };

        $scope.goToProfile = function (profile, pr) {
            localStorage.setItem("INACTIVE_SESSION_TIME", profile.maxInactiveSessionTime)
            if (pr) {
                AuthService.changeSessionObject(pr.userId, pr.profile).then(function () {
                    $state.go($scope.typeCast[profile.type]);
                });
            } else {
                if (profile.type === 'employee') {
                    AuthService.chooseEmployeeProfile(profile._id).then(function () {
                        AuthService.restore().then(function () {
                            $state.go($scope.typeCast[profile.type], {state: 'unread'});
                        });
                    });
                } else {
                    $state.go($scope.typeCast[profile.type]);
                }
            }
        };

        AuthService.getUserData().then(function (user) {
            var profiles = [];
            var studentProfiles = [];

            user.profiles.forEach(function (profile) {
                if (profile.type !== 'student') {
                    profiles.push(profile)
                } else {
                    studentProfiles.push(profile)
                }
            });
            studentProfiles = _.uniqBy(studentProfiles, 'type');
            $scope.profiles = profiles.concat(studentProfiles);

            if (!AuthService.changeMailLater) {
                if (user.email.indexOf('@sangu.edu.ge') === -1) {
                    $state.go('change-mail');
                    return;
                } else if (!user.emailVerified) {
                    $state.go('change-mail', { resend: 'resend' });
                    return;
                }
            }

            if ($scope.profiles.length === 1) {
                return $scope.goToProfile($scope.profiles[0]);
            }
            // TODO design check and save in root scope
            showProfiles();
        });

        function showProfiles() {
            StaticData.getItemsByKey("user_types").then(function (items) {
                $scope.showList = [];
                $scope.profiles.forEach(function (profile) {
                    if((profile.state === 'active' && profile.type !== 'student') || profile.type === 'student') {
                        $scope.showList.push({
                            _id: profile._id,
                            type: profile.type,
                            maxInactiveSessionTime: profile.maxInactiveSessionTime,
                            employeeProfiles: profile.employeeProfiles,
                            description: profile.employee ? profile.employee.position : null,
                            name: items.filter(function (e) {
                                return profile.type === e._id;
                            })[0].name
                        });
                    }
                });
            });
        }
    }
]);
